import { Group, useCurrentWorkspace } from '@gripp/shared-logic';
import { GroupAssignmentColumn } from '../../shared/components/groups/groupAssignmentColumn';

const UPDATE_ROUTINES_GROUPS = `
  mutation UpdateRoutinesGroups($input: UpdateRoutinesGroupsInput!) {
    routine {
      updateRoutinesGroups(input: $input) {
        success
        message
      }
    }
  }
`;

type RoutineGroupsButtonProps = {
  groups: Group[];
  entityId: string;
  name: string;
};

const buildInput = (
  entityId: string,
  workspaceId: string,
  added: { id: string }[],
  removed: { id: string }[]
) => ({
  input: {
    addedGroups: added,
    removedGroups: removed,
    routineIds: [entityId],
    workspaceId,
  },
});

export const RoutineGroupsButton = ({
  groups,
  entityId,
  name,
}: RoutineGroupsButtonProps) => {
  const workspace = useCurrentWorkspace(true);

  if (!workspace?.id) return <></>;

  return (
    <GroupAssignmentColumn
      entityId={entityId}
      entityName={name}
      currentGroups={groups}
      workspaceId={workspace.id}
      mutation={UPDATE_ROUTINES_GROUPS}
      buildInput={buildInput}
      cacheKey="routine"
    />
  );
};
